/**
 * @generated SignedSource<<58a025a51ac7392c8811a5d711a4b4a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentPreviewAttachment$data = {
  readonly dimensions: {
    readonly height: number;
    readonly width: number;
  } | null;
  readonly directUrl: string;
  readonly filename: string;
  readonly filetype: string;
  readonly id: string;
  readonly size: number | null;
  readonly updatedAt: string | null;
  readonly " $fragmentType": "AttachmentPreviewAttachment";
};
export type AttachmentPreviewAttachment$key = {
  readonly " $data"?: AttachmentPreviewAttachment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentPreviewAttachment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "AttachmentPreviewAttachment"
};

(node as any).hash = "ea403984aea008a16bb02512230cedd8";

export default node;
